/**
 * The comment a user is part-way through writing in a card's Add menu. The menu is a popover:
 * Escape backs out of it and a press outside closes it, either of which unmounts the editor and
 * would otherwise take the words with it.
 *
 * By card, so a draft can only come back to the card it was written for, and dropped the moment
 * the comment is added.
 */
const drafts = new Map<string, string>()

export const commentDrafts = {
  /** What the card's draft says, as HTML, or "" when it has none. */
  read: (cardId: string): string => drafts.get(cardId) ?? "",

  save(cardId: string, commentText: string) {
    drafts.set(cardId, commentText)
  },

  clear(cardId: string) {
    drafts.delete(cardId)
  },

  /** Test teardown: a draft outlives its menu on purpose, so it outlives a test too. */
  reset() {
    drafts.clear()
  },
}
